"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Footer", {
    enumerable: true,
    get: function() {
        return Footer;
    }
});
const _components = require("@react-email/components");
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _constants = require("~/constants");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const Footer = ()=>{
    return /*#__PURE__*/ _react.createElement(_components.Container, {
        className: "px-3"
    }, /*#__PURE__*/ _react.createElement(_components.Text, {
        className: "text-gray-500 m-auto text-sm max-w-[400px] text-center"
    }, "NocoDB is your solution for all your no-code needs. Now on cloud, we help organisations maintain critical data with our solutions."), /*#__PURE__*/ _react.createElement(_components.Section, {
        className: "mt-12"
    }, /*#__PURE__*/ _react.createElement(_components.Row, {
        className: "max-w-[100px] m-auto"
    }, /*#__PURE__*/ _react.createElement(_components.Column, null, /*#__PURE__*/ _react.createElement(_components.Link, {
        href: "https://github.com/nocodb",
        target: "_blank"
    }, /*#__PURE__*/ _react.createElement(_components.Img, {
        alt: "Github",
        src: `${_constants.NC_EMAIL_ASSETS_BASE_URL}/social/github.png`,
        height: 32,
        width: 32
    }))), /*#__PURE__*/ _react.createElement(_components.Column, null, /*#__PURE__*/ _react.createElement(_components.Link, {
        href: "https://twitter.com/nocodb",
        target: "_blank"
    }, /*#__PURE__*/ _react.createElement(_components.Img, {
        alt: "X",
        src: `${_constants.NC_EMAIL_ASSETS_BASE_URL}/social/x.png`,
        height: 32,
        width: 32
    }))), /*#__PURE__*/ _react.createElement(_components.Column, null, /*#__PURE__*/ _react.createElement(_components.Link, {
        href: "https://www.youtube.com/@nocodb",
        target: "_blank"
    }, /*#__PURE__*/ _react.createElement(_components.Img, {
        alt: "Youtube",
        height: 32,
        width: 32,
        src: `${_constants.NC_EMAIL_ASSETS_BASE_URL}/social/youtube.png`
    }))), /*#__PURE__*/ _react.createElement(_components.Column, null, /*#__PURE__*/ _react.createElement(_components.Link, {
        href: "http://discord.nocodb.com/",
        target: "_blank"
    }, /*#__PURE__*/ _react.createElement(_components.Img, {
        alt: "Discord",
        src: `${_constants.NC_EMAIL_ASSETS_BASE_URL}/social/discord.png`,
        height: 32,
        width: 32
    }))), /*#__PURE__*/ _react.createElement(_components.Column, null, /*#__PURE__*/ _react.createElement(_components.Link, {
        href: "https://www.linkedin.com/company/nocodb",
        target: "_blank"
    }, /*#__PURE__*/ _react.createElement(_components.Img, {
        alt: "Linkedin",
        src: `${_constants.NC_EMAIL_ASSETS_BASE_URL}/social/linkedin.png`,
        height: 32,
        width: 32
    }))))), /*#__PURE__*/ _react.createElement(_components.Section, {
        className: "mt-6"
    }, /*#__PURE__*/ _react.createElement(_components.Row, {
        className: "max-w-[380px] m-auto"
    }, /*#__PURE__*/ _react.createElement(_components.Column, {
        className: "border pr-1 border-y-0 border-l-0 border-r-1 border-solid border-gray-200"
    }, /*#__PURE__*/ _react.createElement(_components.Link, {
        href: "https://app.nocodb.com/",
        target: "_blank"
    }, /*#__PURE__*/ _react.createElement(_components.Text, {
        className: "text-center underline py-0 !my-0 text-gray-500 text-[13px]"
    }, "Getting Started"))), /*#__PURE__*/ _react.createElement(_components.Column, {
        className: "border border-y-0 px-1 border-l-0 border-r-1 border-solid border-gray-200"
    }, /*#__PURE__*/ _react.createElement(_components.Link, {
        href: "https://nocodb.com/blog",
        target: "_blank"
    }, /*#__PURE__*/ _react.createElement(_components.Text, {
        className: "text-center underline py-0 !my-0 text-gray-500 text-[13px]"
    }, "Blog"))), /*#__PURE__*/ _react.createElement(_components.Column, {
        className: "border px-1 border-y-0 border-l-0 border-r-1 border-solid border-gray-200"
    }, /*#__PURE__*/ _react.createElement(_components.Link, {
        href: "https://nocodb.com/docs/",
        target: "_blank"
    }, /*#__PURE__*/ _react.createElement(_components.Text, {
        className: "text-center underline py-0 !my-0 text-gray-500 text-[13px]"
    }, "Docs"))), /*#__PURE__*/ _react.createElement(_components.Column, {
        className: "pl-1"
    }, /*#__PURE__*/ _react.createElement(_components.Link, {
        href: "https://nocodb.com/terms-of-service",
        target: "_blank"
    }, /*#__PURE__*/ _react.createElement(_components.Text, {
        className: "text-center underline py-0 !my-0 text-gray-500 text-[13px]"
    }, "Terms of Service")))), /*#__PURE__*/ _react.createElement(_components.Row, {
        className: "mt-6"
    }, /*#__PURE__*/ _react.createElement(_components.Column, null, /*#__PURE__*/ _react.createElement(_components.Text, {
        className: "text-center !my-0 text-gray-500 text-[13px]"
    }, new Date().getFullYear(), " — © NocoDB Inc."))), /*#__PURE__*/ _react.createElement(_components.Row, {
        className: "mt-6"
    }, /*#__PURE__*/ _react.createElement(_components.Column, null, /*#__PURE__*/ _react.createElement(_components.Text, {
        className: "text-center !my-0 text-gray-500 text-[13px]"
    }, "All rights reserved.")))));
};
